export default {"src":"/frontend-static/_next/static/media/stack-icon.11525ba1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};